var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"rgb(0,0,0)","fillRule":"evenodd","d":"M8.66461959 7.51731096l6.14531432-6.2661382c.26438764-.28840616.25259365-.73446473-.02666514-1.0084973-.27925878-.27403257-.72547093-.27740874-1.00884452-.00763321L7.6387876 6.491503 1.25153175.2253648C1.06867073.03329567.79561145-.04375537.5393191.02439481.28302672.09254499.08430606.29504606.02100169.55257254c-.06330437.25752648.01888636.52907709.21437573.70827766l6.37757817 6.25646076-6.37757817 6.25646076c-.26978186.28336695-.2664056.72956863.00763339 1.00882087.274039.27925224.72010802.29104596 1.00852094.02666452L7.6387876 8.5431189l6.13563666 6.25646076c.2833736.26977553.72958574.26639936 1.00884452-.0076332.27925879-.27403258.29105278-.72009115.02666514-1.00849732L8.6646196 7.51731096z"}));
}

CloseIcon.defaultProps = {"width":"15.001","height":"15","viewBox":"0 0 15.001 15"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
